import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useState, useRef } from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { messageBoardAction } from '../../actions/messageBoardAction';
import { DABInlineLoading } from '../../components/dab';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import moment from 'moment';

interface IUserProps {
  dispatch: Dispatch<any>;
	messageBoardData: any;
	userId: any;
	fromPage: string;
}

const MessageBoardEngagement: React.SFC<IUserProps> = ({
	dispatch, messageBoardData, userId, fromPage }) => {

	const [isDataLoaded, setIsDataLoaded] = useState(false);
	const [graphOptions, setGraphOptions] = useState({});
	const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

	const year: number = moment().year()

	const handleRefreshGraph = (data) => {
		setGraphOptions({
			chart: {
				type: 'area'
			},
			title: {
				text: 'Message Counts by Board'
			},
			xAxis: {
				categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
			},
			yAxis: {
				min: 0,
				title: {
					text: 'Number Of Messages'
				}
			},
			plotOptions: {
				series: {
					allowPointSelect: true,
					marker: {
						states: {
							select: {
								fillColor: 'red',
								lineWidth: 0
							}
						}
					}
				}
			},
			series: data
		});
	};

	React.useEffect(() => {
		dispatch(messageBoardAction.messageBoardGetCountByYear({ messageCountByMessageBoardGetInput: { year: year, userId: userId } }));
	}, [userId]);

	if (!isDataLoaded && messageBoardData.isBoardMessageCountByYearLoaded) {
		setIsDataLoaded(true);		
		if (messageBoardData.boardMessagesCountByYearData.length > 0) {
			var data = [{}];
			 data = [];
			var monthData = [0];
			messageBoardData.boardMessagesCountByYearData.forEach((item) => {
				monthData = [];
				item.messageCounts.forEach((countData) => {
					monthData.push(countData.count);
				});
				data.push({ name: item.title, data: monthData});
			});
			
			handleRefreshGraph(data);
		}
	}

	return (
		<div className="message-board-engagement">
			{fromPage !== "front" ? <h5>
				<span data-testid="messageBoardEngagementTitle" >Message Board Engagement</span>
			</h5> : ""}			
			{messageBoardData && messageBoardData.boardMessagesCountByYearData &&
				messageBoardData.boardMessagesCountByYearData.length > 0 ?
				<div className='card-box'>
					<div className='card-box-graph' data-testid="messageBoardEngagementChart">
						{messageBoardData && messageBoardData.isLoading ? <DABInlineLoading /> :
							<HighchartsReact
								containerProps={{ style: { height: "100%", width: "100%", padding: "0" } }}
								highcharts={Highcharts}
								options={graphOptions}
								ref={chartComponentRef}
							/>}
					</div>
				</div> :
				<div className={fromPage !== "front" ? "card-box on-empty" : ""}><h5 className="text-center">No data found</h5></div>}
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { messageBoardData } = state;
  return {
		messageBoardData
  };
};

export default connect(mapStateToProps)(MessageBoardEngagement);